export const INITIATE = '[Business Calendar] Initiate';
export const CHANGE_SELECTED_YEAR = '[Business Calendar] Change Selected Year';
